import { toneOfIndex } from './types'

/** Hardcoded directory of external Muslim initiatives (sites, channels, apps)
 *  shown on the /initiatives page, in alphabetical order.
 *  Icons live in frontend/public/assets/initiatives/. */
export enum InitiativeTag {
  Actualites = 'Actualités',
  Application = 'Application',
  Education = 'Éducation',
  Evenements = 'Événements',
  Halal = 'Halal',
  Solidarite = 'Solidarité',
  Sciences = 'Sciences',
  Reseaux = 'Réseaux Sociaux',
}

const TAG_ORDER = Object.values(InitiativeTag)

/** Tone for a tag, assigned round-robin by enum order so colors stay distinct. */
export const initiativeToneOf = (tag: string) =>
  toneOfIndex(TAG_ORDER.indexOf(tag as InitiativeTag))

export interface Initiative {
  name: string
  description: string
  link: string
  image: string
  tags: Array<InitiativeTag>
}

export const INITIATIVES: Array<Initiative> = [
  {
    name: 'Events IDF Islam',
    description:
      'Compte Instagram qui partage les événements de la communauté musulmane en Île-de-France : conférences, rencontres et activités près de chez vous.',
    link: 'https://www.instagram.com/eventsidf.islam/',
    image: '/assets/initiatives/eventsidf.jpg',
    tags: [InitiativeTag.Evenements, InitiativeTag.Reseaux],
  },
  {
    name: 'Hilal France',
    description:
      "Observatoire lunaire qui promeut l'observation du croissant selon des méthodes rigoureuses, alliant approche scientifique, observation de terrain et fidélité à la sunna.",
    link: 'https://hilal-france.fr/',
    image: '/assets/initiatives/hilal-france.png',
    tags: [InitiativeTag.Sciences, InitiativeTag.Actualites],
  },
  {
    name: 'JanazaApp',
    description:
      'Application de géolocalisation des prières funéraires musulmanes : trouvez et partagez les janaza proches de chez vous.',
    link: 'https://janazaapp.fr/',
    image: '/assets/initiatives/janazaapp.png',
    tags: [InitiativeTag.Application],
  },
  {
    name: 'L.E.S. Musulmans',
    description:
      "Association au service des acteurs de la communauté : plateformes dédiées aux mosquées, à la janaza, à l'humanitaire, à l'éducation et à la zakat.",
    link: 'https://lesmusulmans.fr/',
    image: '/assets/initiatives/lesmusulmans.png',
    tags: [InitiativeTag.Solidarite],
  },
  {
    name: 'Majaliss',
    description:
      "Plateforme qui facilite l'accès aux sciences religieuses pour les musulmans et simplifie la gestion administrative et numérique des instituts.",
    link: 'https://majaliss.io/fr',
    image: '/assets/initiatives/majaliss.png',
    tags: [InitiativeTag.Application, InitiativeTag.Education],
  },
  {
    name: 'Mawaqit',
    description:
      'Horaires de prière exacts définis par votre mosquée, notifications et informations de vos mosquées préférées dans plus de 130 pays. Gratuit et sans publicité.',
    link: 'https://www.mawaqit.net/fr/',
    image: '/assets/initiatives/mawaqit.svg',
    tags: [InitiativeTag.Application],
  },
  {
    name: 'Tawakkoul',
    description:
      'Référencement rigoureux de restaurants halal certifiés : carte interactive mise à jour par la communauté et critères de sélection stricts.',
    link: 'https://www.tawakkoul.com/',
    image: '/assets/initiatives/tawakkoul.png',
    tags: [InitiativeTag.Application, InitiativeTag.Halal],
  },
  {
    name: 'Tawqit',
    description:
      'Horaires de prière clairs et fiables via des méthodes de calcul avancées (Asr, Icha, jours polaires).',
    link: 'https://tawqit.org/',
    image: '/assets/initiatives/tawqit.png',
    tags: [InitiativeTag.Application, InitiativeTag.Sciences],
  },
  {
    name: 'Ziyara Project',
    description:
      'Visitez les personnes malades et isolées via l’application Ziyara : devenez bénévole, votre présence peut faire la différence.',
    link: 'https://ziyara-project.com',
    image: '/assets/initiatives/ziyara.jpg',
    tags: [InitiativeTag.Application, InitiativeTag.Solidarite],
  },
]
